/**
 * 平台工厂
 * 根据当前环境返回对应的平台适配器
 */

import type { IPlatformAdapter } from "../types";
import { DingTalkAdapter } from "./DingTalkAdapter";

export enum PlatformType {
  DingTalk = "dingtalk",
  Feishu = "feishu",
  Wework = "wework",
}

/**
 * 获取当前平台类型
 */
function getCurrentPlatform(): PlatformType {
  // 检测当前运行环境
  if (typeof window !== "undefined" && (window as any).Dingdocs) {
    return PlatformType.DingTalk;
  }

  // 默认使用钉钉
  return PlatformType.DingTalk;
}

/**
 * 创建平台适配器
 */
export function createPlatformAdapter(): IPlatformAdapter {
  const platform = getCurrentPlatform();

  switch (platform) {
    case PlatformType.DingTalk:
      return new DingTalkAdapter();

    case PlatformType.Feishu:
      // TODO: 实现飞书适配器
      throw new Error("飞书平台暂未支持");

    case PlatformType.Wework:
      // TODO: 实现企业微信适配器
      throw new Error("企业微信平台暂未支持");

    default:
      return new DingTalkAdapter();
  }
}
